(() => {
  'use strict';
  const STORE = 'https://northcitybistro.com';
  const MONTHS = ['january','february','march','april','may','june','july','august','september','october','november','december'];
  function todayInShoreline(now = new Date()) {
    const p = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const get = type => p.find(x => x.type === type).value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  }
  function cleanText(html) {
    const text = String(html || '').replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi,'').replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi,'').replace(/<[^>]*>/g,' ');
    if (typeof document !== 'undefined') {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = text;
      return decoder.value.replace(/\s+/g,' ').trim();
    }
    const entities = {nbsp:' ',amp:'&',quot:'"',apos:"'",lt:'<',gt:'>'};
    return text.replace(/&(#x[0-9a-f]+|#\d+|nbsp|amp|quot|apos|lt|gt);/gi, (entity, code) => {
      if (code[0] !== '#') return entities[code.toLowerCase()];
      const n = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2),16) : Number(code.slice(1));
      return n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : entity;
    }).replace(/\s+/g,' ').trim();
  }
  function startMinutes(time) {
    const match = String(time || '').match(/(\d{1,2})(?::(\d{2}))?/);
    if (!match) return 24 * 60;
    const hour = Number(match[1]) % 12;
    // The feed uses p.m. by default; an explicit a.m. takes precedence.
    return (hour + (/a\.?\s*m\.?/i.test(time) ? 0 : 12)) * 60 + Number(match[2] || 0);
  }
  function showFromProduct(p, today) {
    const match = String(p.title).match(/(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{1,2})(?:st|nd|rd|th)?(?:\s*,?\s*(20\d{2}))?/i);
    if (!match || !/^[a-z0-9-]+$/.test(p.handle)) return null;
    const month = MONTHS.indexOf(match[1].toLowerCase()) + 1;
    let year = match[3] ? Number(match[3]) : Number(today.slice(0,4));
    // A newly published January show in December belongs to the coming year.
    if (!match[3] && month < Number(today.slice(5,7)) && String(p.created_at).slice(0,7) >= today.slice(0,7)) year++;
    const date = `${year}-${String(month).padStart(2,'0')}-${String(match[2]).padStart(2,'0')}`;
    if (date < today) return null;
    const image = p.images?.[0];
    if (!image || !/^https:\/\/(?:cdn\.shopify\.com|northcitybistro\.com)\//.test(image.src)) return null;
    const description = cleanText(p.body_html);
    const time = description.match(/Show time:\s*([^.!]*p\.m\.|[^.!]*pm)/i)?.[1]?.trim() || null;
    const variants = Array.isArray(p.variants) ? p.variants : [];
    const free = /no ticket|free show/i.test(p.title) && variants.every(v => Number(v.price) === 0);
    const available = variants.some(v => v.available === true);
    const price = variants.length ? Math.min(...variants.map(v => Number(v.price)).filter(Number.isFinite)) : null;
    const title = String(p.title).slice(match.index + match[0].length).replace(/^\s*[-–—:|]\s*/,'').replace(/\s*\(?\s*No Ticket needed.*$/i,'').trim() || String(p.title);
    return {date,title,time,free,available,price,image,handle:p.handle,description,url:`${STORE}/products/${p.handle}`};
  }
  function currentShows(products, today) {
    return products.map(p => showFromProduct(p,today)).filter(Boolean).sort((a,b) => a.date.localeCompare(b.date) || startMinutes(a.time) - startMinutes(b.time));
  }
  function renderShow(show) {
    const card = document.createElement('article'); card.className = 'card';
    const add = (tag,className,text,parent=card) => {const e=document.createElement(tag);e.className=className;e.textContent=text;parent.append(e);return e;};
    const d = new Date(`${show.date}T12:00:00Z`);
    add('div','date',new Intl.DateTimeFormat('en-US',{timeZone:'UTC',weekday:'long',month:'long',day:'numeric'}).format(d));
    const posterLink = add('a','poster-wrap',''); posterLink.href=show.url;posterLink.setAttribute('aria-label',`${show.title}: show details`);
    const img=document.createElement('img');img.className='poster';img.src=show.image.src;img.alt=`${show.title} show poster`;img.width=show.image.width;img.height=show.image.height;img.loading='lazy';img.decoding='async';posterLink.append(img);
    add('h3','',show.title);
    const price = show.free ? 'Free admission' : Number.isFinite(show.price) ? `${new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(show.price)} music cover` : 'See show details';
    add('p','',`${show.time || 'See show page for time'} · ${price}`);
    add('p','availability',show.free ? 'No tickets needed · Reservations recommended' : show.available ? 'Tickets available' : 'Sold out');
    const link=add('a','button',show.free ? 'Show details & reservations' : show.available ? 'Show details & tickets' : 'View sold-out show');link.href=show.url;
    return card;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports={todayInShoreline,showFromProduct,currentShows,startMinutes,cleanText};
  if (typeof document === 'undefined') return;
  window.NCBShows={showFromProduct,currentShows,todayInShoreline};
  const cards=document.getElementById('show-cards'), status=document.getElementById('show-status');
  if(!cards || !status) return;
  let lastCheck=0,loading=false;
  async function refresh() {
    if(loading || Date.now()-lastCheck < 60000) return;
    loading=true;lastCheck=Date.now();const control=new AbortController();const timeout=setTimeout(()=>control.abort(),8000);
    try {
      const response=await fetch(`${STORE}/collections/shows/products.json?limit=250`,{signal:control.signal,cache:'no-store',credentials:'omit'});
      if(!response.ok) throw new Error('Show feed unavailable');
      const data=await response.json();if(!Array.isArray(data.products)) throw new Error('Invalid show feed');
      const shows=currentShows(data.products,todayInShoreline()).slice(0,Number(cards.dataset.limit)||6);
      const fragment=document.createDocumentFragment();shows.forEach(show=>fragment.append(renderShow(show)));cards.replaceChildren(fragment);
      status.textContent=shows.length ? 'Updated from the live show calendar. Ticket pages confirm availability when you purchase.' : 'New shows are being added. View the full calendar or call us for details.';
    } catch(error) {
      // Do not present a cached lineup as current after a failed refresh.
      cards.replaceChildren();status.textContent='We couldn’t refresh the shows. Please use “View full calendar” for current listings and tickets.';
    } finally {clearTimeout(timeout);loading=false;}
  }
  refresh();document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')refresh();});window.addEventListener('focus',refresh);
})();
